const text = require('./text.yaml')[templateVars.lang];
const config = require('./config.yaml');
import {disablePreloaderInItem} from 'component/preloader/index.js';

// На странице теста history
const isHistoryTest = (global.testComponentName && global.testComponentName !== 'history');
// Не нужно отображать history на странице (при служебном запуске сервера)
const noHistory = !isHistoryTest && templateVars.noUserInteraction;

if (!noHistory) {
	class History {
		constructor() {
			this.localforage = global.localforage.createInstance({
				name: `history_${templateVars.site}_${templateVars.lang}`
			});
		}

		//Добавить элемент в историю
		add() {
			const time = moment();
			const link = templateVars.siteUrl.path;
			const itemId = config.outputType === 'all' ? String(time) : link + time.format('DD MMMM YYYY');

			return this.localforage.setItem(itemId, {
				type: 'history',
				site: templateVars.site,
				lang: templateVars.lang,
				title: templateVars.page.shortTitle ? templateVars.page.shortTitle : templateVars.page.title,
				link,
				time: String(time)
			})
				.then(() => {
					return history.checkQuantityOfEls();
				});
		}

		//Проверка колчиества элементов в истории, если больше заданного параметра, то лишние удалить
		checkQuantityOfEls() {
			return this.localforage.length()
				.then(dbLength => {
					if (dbLength > config.maxElements) {
						return history.getList();
					}
				})
				.then(list => {
					if (list) {
						const itemId = list.pop().key;

						return history.removeItem(itemId)
							.then(() => history.checkQuantityOfEls());
					}
				});
		}

		//Удалить элемент
		removeItem(key) {
			return this.localforage.removeItem(key);
		}

		//Оистить историю
		cleanHistory() {
			return this.localforage.clear();
		}

		//Получить историю
		getList() {
			return this.localforage.length()
				.then(dbLength => {
					var itemsArray = [];

					return this.localforage.iterate(function (value, key, iterationNumber) {
						value.key = key;
						itemsArray.push(value);
						if (iterationNumber === dbLength) {
							return itemsArray;
						}
					});
				})
				.then(function (result) {
					//Отсортировать по убыванию
					result.sort(function (a, b) {
						try {
							if (moment(b.time).isAfter(a.time)) {
								return 1;
							} else {
								return -1;
							}
						} catch (err) {
							console.error(err);
						}
						return 0;
					});
					return result;
				});
		}
	}

	var history = new History();

	// Очистка истории на страницах тестов
	if (isHistoryTest) {
		history.cleanHistory();
	}

	Promise.resolve()
		.then(() => {
			if (templateVars.page && !templateVars.page.noHistory && !templateVars.page.isSystem && !isHistoryTest) {
				return history.add();
			}
		})
		.then(() => {
			if ($('#history').length) {
				moment.locale(templateVars.lang);
				return history.getList()
					.then(list => {
						var prevDate = '',
							listCount = -1;
						//Скрыть блок с информацией о пустой истории и показать историю
						$('.history--empty').hide();
						$('#history').show();
						//Вывод истории.
						list.forEach(item => {
							const itemTime = moment(item.time);
							const date = itemTime.format(config.timeFormat[templateVars.lang]);
							const time = itemTime.format('HH:mm');

							//Если дата текущего элемента отличается от предыдущей, то создать отдельный список и добавить в него первый пункт.
							//Иначе, т.е если дата текущего элемента совпадает с предыдущим, то добавить пункт в последний созданный список.
							if (prevDate != date) {
								$('#history').append(`<h4 class="main__date">${date}</h4>
									<ul class="list-history"></ul>`);

								listCount++;
							}

							$('.list-history')
								.eq(listCount)
								.append(`<li class="list-history__item">
									<time class="time" datetime="${itemTime}">${time}</time>
									<a class="list-history__link" href="${item.link}" title="${item.title}" target="_blank">${item.title}</a>
								</li>`);

							prevDate = date;
						});
					})
					.finally(() => {
						$('#history').addClass('history--rendered').triggerHandler('renderComplete');
						disablePreloaderInItem($('.history--empty'));
					});
			}
		})
		.catch(err => {
			console.error(err);
		});

	$('.js-history-btn').on('click', () => {
		history
			.cleanHistory()
			.then((e) => {
				$('.empty-history-message').text(text.clearedText);

				$('#history')
					.velocity('slideUp', {
						duration: 300,
						complete: () => {
							$('.history--empty').slideDown(300);
						}
					});
			});
	});
}



// WEBPACK FOOTER //
// ./temp/components/history/index.js